<div [ngClass]="isValid ? '' : 'plan-info__estimate-datetime--invalid-plan'">
  <ng-container *ngIf="isValid; else invalidPassenger">
    <!-- 有効プランの場合 -->
    <div class="plan-info__passenger-text">
      <!-- [大人] -->
      <ng-container *ngIf="curPassenger.ADT; else noCurADT">
        <!-- 最新カート情報がある場合 -->
        <span
          *ngIf="curPassenger.ADT > 0"
          id="plan-list-plan-information-ADT1"
          [innerHTML]="'label.passengerAdult' | staticMsg : { '0': curPassenger.ADT }"
        ></span>
      </ng-container>
      <ng-template #noCurADT>
        <!-- 最新カート情報がない場合 -->
        <del
          ><span
            *ngIf="(prePassenger.ADT ?? 0) > 0"
            id="plan-list-plan-information-ADT2"
            [innerHTML]="'label.passengerAdult' | staticMsg : { '0': prePassenger.ADT }"
          ></span
        ></del>
      </ng-template>

      <!-- [区切り文字] -->
      <span
        *ngIf="ADT > 0 && B15 > 0"
        id="plan-list-plan-information-passenger-comma-1"
        [innerHTML]="'label.separaterComma' | staticMsg"
      ></span>

      <!-- [ヤングアダルト] -->
      <ng-container *ngIf="curPassenger.B15; else noCurB15">
        <!-- 最新カート情報がある場合 -->
        <span
          *ngIf="curPassenger.B15 > 0"
          id="plan-list-plan-information-B151"
          [innerHTML]="'label.passengerYoungAdult' | staticMsg : { '0': curPassenger.B15 }"
        ></span>
      </ng-container>
      <ng-template #noCurB15>
        <!-- 最新カート情報がない場合 -->
        <del
          ><span
            *ngIf="(prePassenger.B15 ?? 0) > 0"
            id="plan-list-plan-information-B152"
            [innerHTML]="'label.passengerYoungAdult' | staticMsg : { '0': prePassenger.B15 }"
          ></span
        ></del>
      </ng-template>

      <!-- [区切り文字] -->
      <span
        *ngIf="(ADT > 0 || B15 > 0) && CHD > 0"
        id="plan-list-plan-information-passenger-comma-2"
        [innerHTML]="'label.separaterComma' | staticMsg"
      ></span>

      <!-- [小児] -->
      <ng-container *ngIf="curPassenger.CHD; else noCurCHD">
        <!-- 最新カート情報がある場合 -->
        <span
          *ngIf="curPassenger.CHD > 0"
          id="plan-list-plan-information-CHD1"
          [innerHTML]="'label.passengerChild' | staticMsg : { '0': curPassenger.CHD }"
        ></span>
      </ng-container>
      <ng-template #noCurCHD>
        <!-- 最新カート情報がない場合 -->
        <del
          ><span
            *ngIf="(prePassenger.CHD ?? 0) > 0"
            id="plan-list-plan-information-CHD2"
            [innerHTML]="'label.passengerChild' | staticMsg : { '0': prePassenger.CHD }"
          ></span
        ></del>
      </ng-template>

      <!-- [区切り文字] -->
      <span
        *ngIf="(ADT > 0 || B15 > 0 || CHD > 0) && INF > 0"
        id="plan-list-plan-information-passenger-comma-3"
        [innerHTML]="'label.separaterComma' | staticMsg"
      ></span>

      <!-- [幼児] -->
      <ng-container *ngIf="curPassenger.INF; else noCurINF">
        <!-- 最新カート情報がある場合 -->
        <span
          *ngIf="curPassenger.INF > 0"
          id="plan-list-plan-information-INF1"
          [innerHTML]="'label.passengerInfant' | staticMsg : { '0': curPassenger.INF }"
        ></span>
      </ng-container>
      <ng-template #noCurINF>
        <!-- 最新カート情報がない場合 -->
        <del
          ><span
            *ngIf="(prePassenger.INF ?? 0) > 0"
            id="plan-list-plan-information-INF2"
            [innerHTML]="'label.passengerInfant' | staticMsg : { '0': prePassenger.INF }"
          ></span
        ></del>
      </ng-template>
    </div>
  </ng-container>
  <ng-template #invalidPassenger>
    <!-- [大人] -->
    <span
      *ngIf="(prePassenger.ADT ?? 0) > 0"
      id="plan-list-plan-information-ADT3"
      [innerHTML]="'label.passengerAdult' | staticMsg : { '0': prePassenger.ADT }"
    ></span>

    <!-- [区切り文字] -->
    <span
      *ngIf="ADT > 0 && B15 > 0"
      id="plan-list-plan-information-passenger-comma-1"
      [innerHTML]="'label.separaterComma' | staticMsg"
    ></span>

    <!-- [ヤングアダルト] -->
    <span
      *ngIf="(prePassenger.B15 ?? 0) > 0"
      id="plan-list-plan-information-B153"
      [innerHTML]="'label.passengerYoungAdult' | staticMsg : { '0': prePassenger.B15 }"
    ></span>

    <!-- [区切り文字] -->
    <span
      *ngIf="(ADT > 0 || B15 > 0) && CHD > 0"
      id="plan-list-plan-information-passenger-comma-2"
      [innerHTML]="'label.separaterComma' | staticMsg"
    ></span>

    <!-- [小児] -->
    <span
      *ngIf="(prePassenger.CHD ?? 0) > 0"
      id="plan-list-plan-information-CHD3"
      [innerHTML]="'label.passengerChild' | staticMsg : { '0': prePassenger.CHD }"
    ></span>

    <!-- [区切り文字] -->
    <span
      *ngIf="(ADT > 0 || B15 > 0 || CHD > 0) && INF > 0"
      id="plan-list-plan-information-passenger-comma-3"
      [innerHTML]="'label.separaterComma' | staticMsg"
    ></span>

    <!-- [幼児] -->
    <span
      *ngIf="(prePassenger.INF ?? 0) > 0"
      id="plan-list-plan-information-INF3"
      [innerHTML]="'label.passengerInfant' | staticMsg : { '0': prePassenger.INF }"
    ></span>
  </ng-template>
  <div></div>
</div>
